export function isAbsoluteUrl(url) {
  return /^(https?:)?\/\//.test(url);
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/url.js